import React, { Component } from 'react';
import { Grid, Table, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import ptLocale from '@fullcalendar/core/locales/pt';

import { PropTypes } from 'prop-types';
import { DayDetails } from './days/DayDetails';
import { DayForm } from './days/DayForm';
import { EventDetails } from './events/EventDetails';
import { EventForm } from './events/EventForm';
import { EventCalendarAssociationForm } from './events/EventCalendarAssociationForm';
import { EventInterruptionForm } from './events/EventInterruptionForm';
import { TitleRow } from '../../TitleRow';
import { CalendarsCommand } from '../commands/CalendarsCommand';
import { DaysCommand } from '../commands/DaysCommand';
import { EventsCommand } from '../commands/EventsCommand';
import { DayTypesCommand } from '../commands/DayTypesCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';

export class Calendar extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                calendars: new CalendarsCommand(),
                days: new DaysCommand(),
                events: new EventsCommand(),
                dayTypes: new DayTypesCommand(),
            },
            calendars: {
                data: [],
                selected: []
            },
            days: {
                data: [],
                details: undefined,
                form: {
                    title: undefined,
                    day: undefined,
                    original: undefined
                }
            },
            events: {
                data: [],
                details: undefined,
                form: {
                    title: undefined,
                    event: undefined,
                    original: undefined
                },
                associateToCalendarForm: {
                    title: undefined,
                    event: undefined,
                    original: undefined
                },
                stopOnCalendarForm: {
                    title: undefined,
                    event: undefined,
                    original: undefined
                }
            },
            dayTypes: {
                data: []
            },
            fullCalendar: {
                component: (
                    <FullCalendar
                        ref={React.createRef()}
                        locales={[ptLocale]}
                        editable={true}
                        aspectRatio={1.85}
                        navLinks={false}
                        weekNumbers={true}
                        plugins={[dayGridPlugin]}
                        initialView="dayGridMonth"
                        lazyFetching={true}
                        eventSources={[
                            {
                                id: "days",
                                events: (info, successCallback, failureCallback) => {
                                    this.getDays(info, successCallback, failureCallback)
                                },
                                textColor: 'black'
                            }
                        ]}
                        eventClick={(a) => this.handleDetailsClick(a)} />
                ),
                from: "",
                to: ""
            },
            actions: {
                isLoadingEvents: true,
                isUpdatingEvents: false,
                isDeletingEvents: false,

                isLoadingCalendars: true,

                isLoadingDays: true,
                isUpdatingDays: false,
                isDeletingDays: false,

                isLoadingDayTypes: true,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        this.getCalendars();
        this.getEvents();
        this.getDayTypes();
    }

    getCalendars() {
        const { commands, actions } = this.state;

        actions.isLoadingCalendars = true;

        commands.calendars.getAll(
            (a) => this.listCalendarsSuccessCallback(a),
            (a) => this.listCalendarsErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    getDayTypes() {
        const { commands, actions } = this.state;

        actions.isLoadingDayTypes = true;
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        commands.dayTypes.getAll(
            selectedProviderId,
            (a) => this.listDayTypesSuccessCallback(a),
            (a) => this.listDayTypesErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    getDays(info, successCallback, failureCallback) {
        if (undefined === info || undefined === successCallback) {
            return;
        }

        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, calendars, fullCalendar, actions } = this.state;

        fullCalendar.from = info.startStr.split("T")[0];
        fullCalendar.to = info.endStr.split("T")[0];
        actions.isLoadingDays = true;

        commands.days.getAll(
            calendars.selected.join(","),
            fullCalendar.from,
            fullCalendar.to,
            selectedProviderId,
            (a) => this.listDaysSuccessCallback(a, successCallback),
            (a) => this.listDaysErrorCallback(a, failureCallback)
        );

        this.setState({
            actions: actions,
            fullCalendar: fullCalendar
        });
    }

    getEvents() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoadingEvents = true;

        commands.events.getAll(
            selectedProviderId,
            (a) => this.listEventsSuccessCallback(a),
            (a) => this.listEventsErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    // -------------------------

    setErrorMessage(messageReceived) {
        const { message } = this.state;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    setSuccessMessage(messageReceived) {
        const { message } = this.state;
        const updatedMessage = Object.assign({}, message);

        if (message.show) {
            updatedMessage.message = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: updatedMessage
        });
    }

    getDayTitle(day) {
        if (undefined === day.dayTypeName || null === day.dayTypeName || "" === day.dayTypeName) {
            return day.name;
        }

        return `[${day.dayTypeName}] ${day.name}`;
    }

    // -------------------------

    listCalendarsSuccessCallback(result) {
        const { calendars, fullCalendar, actions } = this.state;

        actions.isLoadingCalendars = false;
        calendars.data = result;
        calendars.selected = result.map(item => item.id);

        this.setState({
            actions: actions,
            calendars: calendars
        });

        // Reload fullCalendar events
        fullCalendar.component.ref.current.getApi().getEventSourceById("days").refetch();
    }

    listCalendarsErrorCallback(messageReceived) {
        const { calendars, actions } = this.state;

        actions.isLoadingCalendars = false;
        calendars.data = [];
        this.setErrorMessage(messageReceived);

        this.setState({
            calendars: calendars,
            actions: actions
        });
    }

    listDaysSuccessCallback(result, callback) {
        const { days, actions } = this.state;

        actions.isLoadingDays = false;
        days.data = result;

        this.setState({
            actions: actions,
            days: days
        });

        callback(result.map(
            (day, _) => {
                return {
                    allDay: true,
                    id: day.id,
                    title: this.getDayTitle(day),
                    date: day.date,
                    color: day.isEditable ? "#b3d9ff" : "#fff",
                    extendedProps: {
                        type: "day",
                        isEditable: day.isEditable
                    }
                };
            }
        ));
    }

    listDaysErrorCallback(messageReceived, callback) {
        const { days, actions } = this.state;

        actions.isLoadingDays = false;
        days.data = [];
        this.setErrorMessage(messageReceived);

        this.setState({
            days: days,
            actions: actions
        });

        callback(messageReceived);
    }

    listEventsSuccessCallback(result) {
        const { events, actions } = this.state;

        actions.isLoadingEvents = false;
        events.data = result;

        this.setState({
            actions: actions,
            events: events
        });
    }

    listEventsErrorCallback(messageReceived) {
        const { events, actions } = this.state;

        actions.isLoadingEvents = false;
        events.data = [];
        this.setErrorMessage(messageReceived);

        this.setState({
            events: events,
            actions: actions
        });
    }

    listDayTypesSuccessCallback(result) {
        const { dayTypes, actions } = this.state;

        actions.isLoadingDayTypes = false;
        dayTypes.data = result;

        this.setState({
            actions: actions,
            dayTypes: dayTypes
        });
    }

    listDayTypesErrorCallback(messageReceived) {
        const { dayTypes, actions } = this.state;

        actions.isLoadingDayTypes = false;
        dayTypes.data = [];
        this.setErrorMessage(messageReceived);

        this.setState({
            dayTypes: dayTypes,
            actions: actions
        });
    }

    operationSuccessCallback(messageReceived, updateAction, sourceId, callback) {
        const { fullCalendar, actions } = this.state;

        actions[updateAction] = false;
        this.setSuccessMessage(messageReceived);

        this.setState({
            actions: actions
        });

        // Reload fullCalendar events
        if (undefined !== sourceId && null !== sourceId && "" !== sourceId) {
            fullCalendar.component.ref.current.getApi().getEventSourceById(sourceId).refetch();
        }

        if("function" === typeof callback) {
            callback();
        }
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -------------------------

    handleCalendarRowClick(calendar) {
        const { calendars } = this.state;

        const selectedCalendarIndex = calendars.selected.indexOf(calendar.id);
        if (-1 === selectedCalendarIndex) {
            calendars.selected.push(calendar.id);
        }
        else {
            calendars.selected.splice(selectedCalendarIndex, 1);
        }

        this.setState({
            calendars: calendars
        }, () => {
            const { fullCalendar } = this.state;

            // Reload fullCalendar events
            fullCalendar.component.ref.current.getApi().getEventSourceById("days").refetch();
        });
    }

    handleCreateEventClick(calendarStartViewDate) {
        const { events } = this.state;

        events.form.original = null;
        events.form.event = {
            id: 0,
            name: "",
            beginDate: calendarStartViewDate,
            endDate: ""
        };
        events.form.title = "Criar Evento";

        this.setState({
            events: events
        });
    }

    handleDetailsClick(info) {
        switch (info.event.extendedProps.type) {
            // case "event":
            //     this.handleDetailsEventClick(info.event);
            //     break;

            case "day":
                if(info.event.extendedProps.isEditable) {
                    this.handleDetailsDayClick(info.event);
                }
                break;

            default: // DO NOTHING
        }
    }

    handleDetailsDayClick(event) {
        const { days } = this.state;

        days.details = days.data.find(day => `${day.id}` === `${event.id}`);

        this.setState({
            days: days
        });
    }

    handleEditDayClick(day) {
        const { days, dayTypes } = this.state;
        const dayObj = days.data.find(d => `${d.id}` === `${day.id}`);

        days.form.original = dayObj;
        days.form.day = Object.assign({dayType: dayTypes.data.find(dayType => dayType.id === day.dayTypeId)}, dayObj);
        days.form.title = `Editar Dia - ${day.name}`;

        this.setState({
            days: days
        });
    }

    handleDaySave(day) {
        const { commands } = this.state;
        commands.days.save(
            day,
            (a) => this.operationSuccessCallback(a, "isUpdatingDays", "days"),
            (a) => this.operationErrorCallback(a, "isUpdatingDays")
        );

        this.handleDayDetailsExit();
        this.handleDayFormExit("form");
    }

    handleDeleteDayClick(day) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o dia "${day.name}" em ${day.date}`,
                style: "warning",
                icon: "alert",
                argument: {
                    type: "day",
                    id: day.id,
                    calendarId: day.calendarId,
                    action: "isDeletingDays",
                    source: "days",
                    function: () => {
                        this.handleDayDetailsExit();
                    },
                    callback: () => {
                        this.getEvents();
                    }
                }
            }
        });
    }

    handleDayFormExit(form) {
        const { days } = this.state;

        days[form] = {
            title: undefined,
            event: undefined,
            original: undefined,
        };

        this.setState({
            days: days
        });
    }

    handleDayDetailsExit() {
        const { days } = this.state;

        days.details = undefined;

        this.setState({
            days: days
        });
    }

    handleDetailsEventClick(event) {
        const { events } = this.state;

        events.details = events.data.find(evt => `${evt.id}` === `${event.id}`);

        this.setState({
            events: events
        });
    }

    handleAssociateToCalendarClick(event) {
        const { events } = this.state;
        const evt = events.data.find(evt => `${evt.id}` === `${event.id}`);

        events.associateToCalendarForm.original = evt;
        events.associateToCalendarForm.event = Object.assign({}, evt);
        events.associateToCalendarForm.title = `Associar Evento ${evt.name} a Calendário`;

        this.setState({
            events: events
        });
    }

    handleStopOnCalendarClick(event) {
        const { events } = this.state;
        const evt = events.data.find(evt => `${evt.id}` === `${event.id}`);

        events.stopOnCalendarForm.original = evt;
        events.stopOnCalendarForm.event = Object.assign({}, evt);
        events.stopOnCalendarForm.title = `Interromper Evento ${evt.name}`;

        this.setState({
            events: events
        });
    }

    handleEditEventClick(event) {
        const { events } = this.state;
        const evt = events.data.find(evt => `${evt.id}` === `${event.id}`);

        events.form.original = evt;
        events.form.event = Object.assign({}, evt);
        events.form.title = "Editar Evento";

        this.setState({
            events: events
        });
    }

    handleEventSave(event) {
        const { commands, actions } = this.state;
        commands.events.save(
            event,
            (a) => this.operationSuccessCallback(a, "isUpdatingEvents", "days", () => this.getEvents()), // To get updated days when updating the events
            (a) => this.operationErrorCallback(a, "isUpdatingEvents")
        );

        actions.isUpdatingEvents = true;

        this.handleEventDetailsExit();
        this.handleEventFormExit("form");

        this.setState({
            actions: actions
        });
    }

    handleEventCalendarAssociationSave(event) {
        const { commands, actions } = this.state;
        commands.events.associateToCalendar(
            event,
            (a) => this.operationSuccessCallback(a, "isUpdatingEvents", "days", () => this.getEvents()), // To get newly generated days
            (a) => this.operationErrorCallback(a, "isUpdatingEvents")
        );

        actions.isUpdatingEvents = true;

        this.handleEventDetailsExit();
        this.handleEventFormExit("associateToCalendarForm");

        this.setState({
            actions: actions
        });
    }

    handleEventInterruptionSave(event) {
        const { commands, actions } = this.state;
        commands.events.stopOnCalendar(
            event,
            (a) => this.operationSuccessCallback(a, "isUpdatingEvents", "days", () => this.getEvents()), // To get newly generated days
            (a) => this.operationErrorCallback(a, "isUpdatingEvents")
        );

        actions.isUpdatingEvents = true;

        this.handleEventDetailsExit();
        this.handleEventFormExit("stopOnCalendarForm");

        this.setState({
            actions: actions
        });
    }

    handleDeleteEventClick(event) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o evento "${event.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    type: "event",
                    id: event.id,
                    action: "isDeletingEvents",
                    source: "days",
                    function: () => {
                        this.handleEventDetailsExit();
                    },
                    callback: () => {
                        this.getEvents();
                    }
                }
            }
        });
    }

    handleEventFormExit(form) {
        const { events } = this.state;

        events[form] = {
            title: undefined,
            event: undefined,
            original: undefined,
        };

        this.setState({
            events: events
        });
    }

    handleEventDetailsExit() {
        const { events } = this.state;

        events.details = undefined;

        this.setState({
            events: events
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;

            switch(argument.type) {
                case "event":
                    commands.events.delete(
                        argument.id,
                        (a) => this.operationSuccessCallback(a, argument.action, argument.source, argument.callback),
                        (a) => this.operationErrorCallback(a, argument.action)
                    );
                    break;

                case "day":
                    commands.days.delete(
                        argument.calendarId,
                        argument.id,
                        (a) => this.operationSuccessCallback(a, argument.action, argument.source, argument.callback),
                        (a) => this.operationErrorCallback(a, argument.action)
                    );
                    break;

                default: // DO NOTHING
            }

            actions[argument.action] = true;

            if ("function" === typeof argument.function) {
                argument.function();
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -------------------------

    isLoading(actions) {
        return actions.isLoadingEvents || actions.isUpdatingEvents || actions.isDeletingEvents || 
            actions.isLoadingCalendars || 
            actions.isLoadingDayTypes || 
            actions.isLoadingDays || actions.isUpdatingDays || actions.isDeletingDays;
    }

    renderDayDetails() {
        const { days } = this.state;

        if (null === days.details || undefined === days.details) {
            return null;
        }

        return (
            <DayDetails day={days.details}
                onEdit={(a) => this.handleEditDayClick(a)}
                onDelete={(a) => this.handleDeleteDayClick(a)}
                onHide={() => this.handleDayDetailsExit()} />
        );
    }

    renderDayForm() {
        const { days } = this.state;

        if (null === days.form.day || undefined === days.form.day) {
            return null;
        }

        const { dayTypes } = this.state;

        return (
            <DayForm title={days.form.title}
                day={days.form.day}
                dayTypes={dayTypes.data}
                onSave={(a) => this.handleDaySave(a)}
                onHide={() => this.handleDayFormExit("form")} />
        );
    }

    renderEventDetails() {
        const { events } = this.state;

        if (null === events.details || undefined === events.details) {
            return null;
        }

        const { dayTypes } = this.state;

        return (
            <EventDetails event={events.details}
                dayTypes={dayTypes.data}
                onAssociateToCalendar={(a) => this.handleAssociateToCalendarClick(a)}
                onStopOnCalendar={(a) => this.handleStopOnCalendarClick(a)}
                onEdit={(a) => this.handleEditEventClick(a)}
                onDelete={(a) => this.handleDeleteEventClick(a)}
                onHide={() => this.handleEventDetailsExit()} />
        );
    }

    renderEventForm() {
        const { events } = this.state;

        if (null === events.form.event || undefined === events.form.event) {
            return null;
        }

        const { dayTypes } = this.state;

        return (
            <EventForm title={events.form.title}
                dayTypes={dayTypes.data}
                event={events.form.event}
                onSave={(a) => this.handleEventSave(a)}
                onHide={() => this.handleEventFormExit("form")} />
        );
    }

    renderEventCalendarAssociationForm() {
        const { events } = this.state;

        if (null === events.associateToCalendarForm.event || undefined === events.associateToCalendarForm.event) {
            return null;
        }

        const { calendars, dayTypes } = this.state;

        return (
            <EventCalendarAssociationForm title={events.associateToCalendarForm.title}
                event={events.associateToCalendarForm.event}
                calendars={calendars.data}
                dayTypes={dayTypes.data}
                onSave={(a) => this.handleEventCalendarAssociationSave(a)}
                onHide={() => this.handleEventFormExit("associateToCalendarForm")} />
        );
    }

    renderEventInterruptionForm() {
        const { events } = this.state;

        if (null === events.stopOnCalendarForm.event || undefined === events.stopOnCalendarForm.event) {
            return null;
        }

        const { calendars } = this.state;

        return (
            <EventInterruptionForm title={events.stopOnCalendarForm.title}
                event={events.stopOnCalendarForm.event}
                calendars={calendars.data}
                onSave={(a) => this.handleEventInterruptionSave(a)}
                onHide={() => this.handleEventFormExit("stopOnCalendarForm")} />
        );
    }

    render() {
        const { calendars, events, fullCalendar, actions, message, dialog } = this.state;

        return (
            <div>
                <TitleRow title="Calendário" showSeparator={true}>
                    <Col className="padding-0" xs={12} sm={12} md={12}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.handleCreateEventClick(fullCalendar.from)}>CRIAR EVENTO</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    <Grid fluid className="table-small-screens">
                        <Row>
                            <Col xs={12} sm={3} md={2}>
                                <Table responsive striped hover >
                                    <thead>
                                        <tr>
                                            <th>Calendários</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            calendars.data.map((calendar, idx) =>
                                                <tr key={`calendar-${idx}`}
                                                    className={`datamanager selectable ${undefined !== calendars.selected.find(item => item === calendar.id) ? "checked" : ""}`}
                                                    onClick={() => this.handleCalendarRowClick(calendar)}>
                                                    <td>{calendar.name}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>
                            </Col>

                            <Col xs={12} sm={6} md={8}>
                                {fullCalendar.component}
                            </Col>

                            <Col xs={12} sm={3} md={2}>
                                <Table responsive striped hover >
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>Eventos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            events.data.map((event, idx) =>
                                                <tr key={`event-${idx}`}
                                                    className="selectable"
                                                    onClick={() => this.handleDetailsEventClick(event)}>
                                                    <td className="width-1p"><span className={`${event.hasDays ? "icon-select" : ""} float-left`}></span></td>
                                                    <td>{event.name}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Grid>
                </div>

                {this.renderDayDetails()}
                {this.renderDayForm()}

                {this.renderEventDetails()}
                {this.renderEventForm()}
                {this.renderEventCalendarAssociationForm()}
                {this.renderEventInterruptionForm()}

                <HandleMessage
                    title="A Carregar..."
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={this.isLoading(actions)}
                    small
                    noButtons />

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/calendar/Calendar.js